import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import React, { ChangeEvent } from "react";
import { RenderersUIType } from "@home-health-notify/domain";
import theme from "../../../theme";

const InputWithAdornmentsRenderer = ({
  path,
  data,
  handleChange,
  uischema,
  schema,
  errors,
  required,
}: ControlProps) => {
  const { label, options } = uischema;
  const { type } = schema;
  const { suffix, prefix } = options || {};

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      handleChange(path, value);
    } else {
      handleChange(path, e.target.value);
    }
  };

  return (
    <TextField
      required={required}
      label={label?.toString()}
      value={data}
      type={type as string}
      onChange={onChange}
      id="outlined-start-adornment"
      error={!!errors}
      helperText={errors || ""}
      sx={{
        mb: 0.75,
        width: "100%",
      }}
      slotProps={{
        input: {
          startAdornment: prefix && (
            <InputAdornment position="start">
              <Typography
                style={{ color: theme.palette.primary.main, fontSize: "14px" }}
              >
                {prefix}
              </Typography>
            </InputAdornment>
          ),
          endAdornment: suffix && (
            <InputAdornment position="start">
              <Typography
                style={{ color: theme.palette.primary.main, fontSize: "14px" }}
              >
                {suffix}
              </Typography>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export const inputWithAdornmentsTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.InputWithAdornment)),
);

export default withJsonFormsControlProps(InputWithAdornmentsRenderer);
